import {
  Paper,
  Typography,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormGroup,
} from "@material-ui/core";
import {preventDoubleClick} from "./preventDC.js"
import { makeStyles } from "@material-ui/core/styles";
import {
  fetchfunnellength,
  openfupcountbysp,
  fetchleadbasedcustdata,
  getmanualfrbydate2,
  searchLeadsbyDate,
  fetchEmployees,
  fetchDest,
  deleteTripbyId,
  fetchLeadsbyNumber,
  fetchLeadsbyEmail,
  fetchTripsbyNumber,
  fetchReftrips,
  fetchTripsbyName,
  fetchLeadsbyName,
  reactivatebydate,
  fetchCustomersbyOwner,
  newupdateLeaddata3,
  
} from "../api/customerapi";
import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import GetRole from "./user";
import {CSVLink} from "react-csv"
import { getquality,newgetqualitylead, classifyleadcreationtime, reversesortByKey, getLeadCallTimeSummary, sortByKey} from "./date";



const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  modalText: {
    marginLeft: theme.spacing(30),
    marginRight: theme.spacing(4),
    width: theme.spacing(120),
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(2),
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  headertext: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(14),
    height: theme.spacing(5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: 10,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
}));

const Lead = () => {
  const width = window.innerWidth - 200;
  const classes = useStyles();
  const lcolumns = [
    {
      field: "lead_id",
      headerName: " Lead ID",
      width: width / 12*0.75,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "lead_name",
      headerName: "lead Name",
      width: (width / 12) * 1.5,
    },
    {
      field: "phone",
      headerName: "Contact",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_status",
      headerName: "Quality",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_destination",
      headerName: "Destination",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_createdAt",
      headerName: "Created At",
      width: (width / 12) * 1.5,
    },
    
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12,
    },
    // {
    //   field: "lead_assignedAt",
    //   headerName: "Assigned At",
    //   width: (width / 12),
    // },
    {
      field: "lead_source",
      headerName: "Source",
      width: (width / 12),
    },
    {
      field: "lead_platform",
      headerName: "Channel",
      width: (width / 12),
    },
    {
      field: "meta_campaign",
      headerName: "Meta Campign",
      width: width / 12,
    },
    {
      field: "landing_page",
      headerName: "LP",
      width: width / 12,
    },
    {
      field: "work_done_time",
      headerName: "Work Done?",
      width: width / 12,
    },
    // {
    //   field: "time_to_action",
    //   headerName: "TTA",
    //   width: (width / 12),
    // },
    {
      field: "start_date",
      headerName: "Start Date",
      width: (width / 12),
    },
    {
      field: "email",
      headerName: "Email",
      width: width / 12,
    },
    {
      field: "lead_canc",
      headerName: "Cancelled?",
      width: width / 12,
    },
    {
      field: "potential",
      headerName: "Potential?",
      width: width / 12*0.5,
    },

    {
      field: "only_wa",
      headerName: "Only WA",
      width: width / 12*0.5,
    },
     {
      field: "lead_pax",
      headerName: "Pax",
      width: width / 12,
    },
    {
      field: "lead_travel_date",
      headerName: "Start Date",
      width: width / 12,
    },
    {
      field: "caller",
      headerName: "Caller",
      width: width / 12,
    },
    {
      field: "fc_time",
      headerName: "Call Time",
      width: width / 12*2,
    },
    {
      field: "gap",
      headerName: "Gap",
      width: width / 12,
    },
     {
      field: "manual_fr",
      headerName: "Manual FR",
      width: width / 12*2,
    },
    {
      field: "call_duration",
      headerName: "Duration",
      width: width / 12,
    },
    {
      field: "call_creation_category",
      headerName: "Category",
      width: width / 12,
    },
    {
      field: "fr_wa",
      headerName: "WA Sent",
      width: width / 12,
    },
    {
      field: "ref_code",
      headerName: "Ref Code",
      width: width / 12,
    },
  ];
  const lcolumns2 = [
    {
      field: "lead_id",
      headerName: " Lead ID",
      width: width / 12*0.75,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "lead_name",
      headerName: "lead Name",
      width: (width / 12) * 1.75,
    },
    {
      field: "phone",
      headerName: "Contact",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_status",
      headerName: "Quality",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_destination",
      headerName: "Destination",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_createdAt",
      headerName: "Created At",
      width: (width / 12) * 1,
    },
    
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12,
    },
    {
      field: "lead_assignedAt",
      headerName: "Travel Date",
      width: (width / 12),
    },
  
    {
      field: "work_done",
      headerName: "Work Done?",
      width: width / 12*0.5,
    },
    {
      field: "work_done_time",
      headerName: "Work Done?",
      width: width / 12,
    },
    {
      field: "time_to_action",
      headerName: "TTA",
      width: (width / 12),
    },
    {
      field: "email",
      headerName: "Email",
      width: width / 12,
    },
    {
      field: "lead_canc",
      headerName: "Cancelled?",
      width: width / 12,
    },
    {
      field: "potential",
      headerName: "Potential?",
      width: width / 12*0.5,
    },
    {
      field: "only_wa",
      headerName: "Only WA",
      width: width / 12*0.5,
    },
  ];
  const lcolumns5 = [
    {
      field: "lead_id",
      headerName: " Lead ID",
      width: width / 12*0.75,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "manualfr",
      headerName: "Manual FR",
      width: (width / 12) * 1.75,
    },
    {
      field: "fr",
      headerName: "FR",
      width: (width / 12)*0.75,
    },
     {
      field: "fra",
      headerName: "FR_Attempted",
      width: (width / 12)*0.75,
    },
     {
      field: "manual_fra_time",
      headerName: "Manual FR_Time",
      width: (width / 12)*2,
    },
    {
      field: "quote_time",
      headerName: "Quote Time",
      width: (width / 12)*2,
    },
    
  ];
  const columns2 = [
    {
      field: "lead_id",
      headerName: " Lead ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "lead_name",
      headerName: "lead Name",
      width: width / 12,
    },
    {
      field: "lead_status",
      headerName: "Status",
      width: (width / 12),
    },
    {
      field: "phone",
      headerName: "Contact",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_destination",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "lead_createdAt",
      headerName: "Created At",
      width: (width / 12) * 1.5,
    },
    {
      field: "lead_createdAt_time",
      headerName: "Created Time",
      width: (width / 12) * 1.5,
    },
    {
      field: "lead_owner",
      headerName: "Owner",
      width: width / 12,
    },
    {
      field: "quality",
      headerName: "Quality",
      width: width / 12,
    },
    {
      field: "lead_assignedAt",
      headerName: "Assigned At",
      width: (width / 12) * 1.5,
    },
    {
      field: "work_done",
      headerName: "Work Done?",
      width: width / 12,
    },
    {
      field: "work_done_time",
      headerName: "Work Done Time?",
      width: (width / 12) * 1.5,
    },
    {
      field: "time_to_action",
      headerName: "TTA",
      width: (width / 12),
    },
  ];
  const columns3 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: width / 12,
    },
    {
      field: "trip_destination",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: (width / 12) * 1.5,
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12) * 1.5,
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: width / 12,
    },
    {
      field: "email",
      headerName: "Email",
      width: width / 12,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: width / 12,
    },
  ];
  const columns9 = [
    {
      field: "lead_id",
      headerName: "Lead Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: width / 12,
    },
    {
      field: "canc_reason",
      headerName: "Canc Reason",
      width: width / 12* 1.5,
    },
    {
      field: "cust_id",
      headerName: "Cust Id",
      width: (width / 12) ,
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12) ,
    },
    {
      field: "cust_canc_reason",
      headerName: "Cust Canc Reason",
      width: width / 12* 1.5,
    },
    {
      field: "check_updated",
      headerName: "Check Update Date",
      width: (width / 12) ,
    },
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 12) ,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: (width / 12) ,
    },
     {
      field: "quote_id",
      headerName: "Quote Id",
      width: (width / 12) ,
    },
    {
      field: "wd",
      headerName: "Work Done?",
      width: (width / 12) ,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) ,
    },
    {
      field: "owner",
      headerName: "Owner",
      width: (width / 12) ,
    },
    {
      field: "sumleadcalltime",
      headerName: "Lead Call Time Sum",
      width: (width / 12) ,
    },
     {
      field: "quality",
      headerName: "Quality",
      width: (width / 12) ,
    },
  ];
  const columns10 = [
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
   
    
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: (width / 12) ,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: (width / 12) ,
    },
    {
      field: "fup",
      headerName: "FUP Date",
      width: (width / 12) ,
    },
     {
      field: "rdate",
      headerName: "Reactivated Date",
      width: (width / 12) ,
    },
     {
      field: "fup_count",
      headerName: "FUP after RD",
      width: (width / 12) ,
    },
     {
      field: "mobile",
      headerName: "Mobile",
      width: (width / 12) ,
    },
  ];
const headers10=[
   
    {label:"Reactivated Date", key:"rdate"},
    {label:"FUP Count after reactivation", key:"fup_count"},
    {label:"Mobile Number", key:"mobile"},
    {label:"Trip Status", key:"trip_status"},
    {label:"Owner", key:"trip_owner"},
    {label:"Trip Id", key:"trip_id"},
   

]

  const headers=[
    {label:"Owner", key:"lead_owner"},
    {label:"Name", key:"lead_name"},
    {label:"Lead Id", key:"lead_id"},
    {label:"Mobile Number", key:"phone"},
    {label:"Email", key:"email"},
    {label:"Status", key:"lead_status"},
    {label:"Source", key:"lead_source"},
    {label:"Platform", key:"lead_platform"},
    {label:"LP", key:"landing_page"},
    {label:"Work Done", key:"work_done"},
    {label:"Work Done Time", key:"work_done_time"},
    {label:"Cancelled?", key:"lead_canc"},
    {label:"Destination", key:"lead_destination"},
    {label:"Start Date", key:"start_date"},
    {label:"CreatedAt", key:"lead_createdAt"},
    {label:"AssignedAt", key:"lead_assignedAt"},
    {label:"Only WA", key:"only_wa"},
    {label:"Travel Date", key:"lead_travel_date"},
    {label:"Pax", key:"lead_pax"},
    {label:"Category", key:"call_creation_category"},
    {label:"Duration", key:"call_duration"},
    {label:"Manual FR", key:"manual_fr"},
    {label:"Gap", key:"gap"},
    {label:"Call Time", key:"fc_time"},
    {label:"Caller", key:"caller"},
    {label:"Ref Code", key:"ref_code"},
]

  const headers9=[
    {label:"Owner", key:"owner"},
    {label:"Canc Reason", key:"canc_reason"},
    {label:"Lead Id", key:"lead_id"},
    {label:"Mobile Number", key:"mobile"},
    {label:"Trip Status", key:"trip_status"},
    {label:"Status", key:"status"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Quote Id", key:"quote_id"},
    {label:"Check Updated", key:"check_updated"},
    {label:"Work Done", key:"wd"},
    {label:"Cust Canc Reason", key:"cust_canc_reason"},
    {label:"cust_status", key:"status"},
    {label:"Destination", key:"dest"},
    {label:"Cust Id", key:"cust_id"},
    {label:"Sum of Lead Call Time", key:"sumleadcalltime"},
    {label:"Quality", key:"quality"},
]
  var [listtripData2, setlisttripData2] = useState([{}]);
  const [listleadData, setlistleadData] = useState([
    {
      lead_destination: "",
    },
  ]);
  const [selection, setselection] = useState([]);
  const [listleadData2, setlistleadData2] = useState([
    {
      lead_destination: "",
    },
  ]);
  const [leadselectionData, setleadselectionData] = useState([]);
  const [listleadData3, setlistleadData3] = useState([{}]);
  const [listleadData4, setlistleadData4] = useState([{}]);
  const [listleadData5, setlistleadData5] = useState([{}]);
  var [listtripData, setlisttripData] = useState([{}]);
  var [filterdata1, setfilterdata1] = useState({});
  var [filterdata2, setfilterdata2] = useState({});
  var [leadfilterData, setleadfilterData] = useState({});
  const [searchData7, setsearchData7] = useState([{}]);
  const [searchData3, setsearchData3] = useState([{}]);
  const [searchData4, setsearchData4] = useState([{}]);
  const [searchData5, setsearchData5] = useState([{}]);
  const [searchData6, setsearchData6] = useState([{}]);
  const [searchData8, setsearchData8] = useState([{}]);
  const [searchData9, setsearchData9] = useState([{}]);
  const [emp, setemp] = useState([]);
  const [emp2, setemp2] = useState([]);
  const [dest, setdest] = useState([]);
  const [leadcustdata, setleadcustdata] = useState([]);
  const [leadcustdata2, setleadcustdata2] = useState([]);
  const [leadcustdata3, setleadcustdata3] = useState([]);
  const [leadcustdata4, setleadcustdata4] = useState([]);
  // const uploadlead = async () => {
  //   //console.log("working")
  //   let sheetid = prompt("Enter sheet number you want to load:");
  //   const creds = require("../jeto-crm-333115-f410aed2044d.json");
  //   //const {promisify} = require("util")
  //   const { GoogleSpreadsheet } = require("google-spreadsheet");
  //   const doc = new GoogleSpreadsheet(
  //     "1lcu-M7CJrnzAs5LUB7R7qjbPVntoqSk-R_zTq68i6wQ"
  //   );
  //   //await promisify(doc.useServiceAccountAuth)(creds);
  //   await doc.useServiceAccountAuth(creds);

  //   // await doc.useServiceAccountAuth({
  //   //     // env var values are copied from service account credentials generated by google
  //   //     // see "Authentication" section in docs for more info
  //   //     client_email: process.env.client_email,
  //   //     private_key: process.env.private_key,
  //   //     //client_email: "jeto-crm-sheets@jeto-crm-333115.iam.gserviceaccount.com",
  //   //     //private_key: "f410aed2044da3108fafcdaa2596b5057564288c",
  //   //   });
  //   //console.log(doc);
  //   await doc.loadInfo(); // loads document properties and worksheets
  //   //console.log(doc);
  //   console.log(doc.title);
  //   const lead = {
  //     lead_name: "",
  //     mobile_number: 0,
  //     email_id: "",
  //     lead_status: "",
  //     lead_campaign: "",
  //     lead_platform: "",
  //     lead_destination: "",
  //     lead_pax: "",
  //     lead_travel_date: "",
  //     lead_travel_date_decided: "",
  //     lead_id: 0,
  //     lead_owner: "",
  //     canc_reason_notes: "",
  //     work_complete: false,
  //   };
  //   var leadloadcount = 0;

  //   const sheet = doc.sheetsByIndex[sheetid]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]

  //   if (sheet == null || sheet == undefined) {
  //     alert("Sheet does not exist");
  //     window.location = "/lead";
  //   }
  //   // await sheet.loadCells('A1:J100');
  //   // const b2 = sheet.getCellByA1('A1')
  //   // console.log(b2.value)
  //   const rows = await sheet.getRows();
  //   for (let i = 0; i < rows.length; i++) {
  //     lead.lead_name = rows[i].full_name;
  //     lead.mobile_number = rows[i].phone;
  //     lead.email_id = rows[i].email;
  //     lead.lead_destination = rows[i].destination;
  //     lead.lead_pax = rows[i].number_of_passengers;
  //     lead.lead_travel_date_decided = rows[i].travel_date_decided;
  //     lead.lead_travel_date = rows[i].date_of_travel;
  //     lead.lead_platform = rows[i].platform;
  //     lead.lead_campaign = rows[i].campaign;
  //     lead.lead_owner = rows[i].owner;
  //     lead.cust_create = true;
  //     lead.createdAt = new Date();
  //     console.log(lead);
  //     if (lead.mobile_number !== null) {
  //       const addleadResponse = await addLead(lead);
  //       //console.log(addleadResponse)
  //       if (
  //         addleadResponse.status == 200 ||
  //         201 ||
  //         202 ||
  //         203 ||
  //         204 ||
  //         205 ||
  //         206 ||
  //         207
  //       ) {
  //         leadloadcount++;
  //         setleadData(leadloadcount);
  //         //console.log(leadloadcount)
  //       }
  //     }
  //   }

  //   //console.log(rows.length)

  //   if (rows.length > 0) {
  //     if (rows.length == leadloadcount) {
  //       alert(
  //         leadloadcount + " leads succesfully uploaded from " + sheet.title
  //       );
  //     } else {
  //       alert(
  //         rows.length +
  //           " leads found but " +
  //           leadloadcount +
  //           " leads succesfully uploaded from " +
  //           sheet.title
  //       );
  //     }
  //   } else {
  //     alert("No leads found");
  //   }
  // };
  var {cuser, role}=GetRole();
  // const uploadmsg = async () => {
  //   //console.log("working")
  //   let sheetid = prompt("Enter sheet number you want to load:");
  //   const creds = require("../jeto-crm-333115-f410aed2044d.json");

  //   const { GoogleSpreadsheet } = require("google-spreadsheet");
  //   const doc = new GoogleSpreadsheet(
  //     "1D7huwcWGlh0prUBXL4KVYlxd5wpo3IKvQvuq7F__mVg"
  //   );
  //   //await promisify(doc.useServiceAccountAuth)(creds);
  //   await doc.useServiceAccountAuth(creds);

  //   // await doc.useServiceAccountAuth({
  //   //     // env var values are copied from service account credentials generated by google
  //   //     // see "Authentication" section in docs for more info
  //   //     client_email: process.env.client_email,
  //   //     private_key: process.env.private_key,
  //   //     //client_email: "jeto-crm-sheets@jeto-crm-333115.iam.gserviceaccount.com",
  //   //     //private_key: "f410aed2044da3108fafcdaa2596b5057564288c",
  //   //   });
  //   //console.log(doc);
  //   await doc.loadInfo(); // loads document properties and worksheets
  //   //console.log(doc);
  //   //console.log(doc.title);
  //   const msg = {
  //     wa_id: 0,
  //     wa_name: "",
  //     wa_owner: "",
  //     wa_body: "",
  //     wa_category: "",
  //     wa_custom: false,
  //     wa_cust: false,
  //     wa_trip: false,
  //   };
  //   var msgloadcount = 0;

  //   const sheet = doc.sheetsByIndex[sheetid]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]

  //   if (sheet == null || sheet == undefined) {
  //     alert("Sheet does not exist");
  //     window.location = "/lead";
  //   }
  //   // await sheet.loadCells('A1:J100');
  //   // const b2 = sheet.getCellByA1('A1')

  //   const rows = await sheet.getRows();
  //   console.log(rows.length);
  //   for (let i = 0; i < rows.length; i++) {
  //     msg.wa_id = rows[i].wa_id;
  //     msg.wa_name = rows[i].wa_name;
  //     msg.wa_category = rows[i].wa_category;
  //     msg.wa_body = rows[i].wa_body;
  //     msg.wa_owner = rows[i].wa_owner;
  //     msg.wa_custom = rows[i].wa_custom;
  //     msg.wa_cust = rows[i].wa_cust;
  //     msg.wa_trip = rows[i].wa_trip;
  //     console.log(msg.wa_name);

  //     const addleadResponse = await addMsg(msg);
  //     //console.log(addleadResponse)
  //     if (
  //       addleadResponse.status == 200 ||
  //       201 ||
  //       202 ||
  //       203 ||
  //       204 ||
  //       205 ||
  //       206 ||
  //       207
  //     ) {
  //       msgloadcount++;
  //       setmsgData(msgloadcount);
  //       //console.log(leadloadcount)
  //     }
  //   }

  //   //console.log(rows.length)

  //   if (rows.length > 0) {
  //     if (rows.length == msgloadcount) {
  //       alert(
  //         msgloadcount + " messages succesfully uploaded from " + sheet.title
  //       );
  //     } else {
  //       alert(
  //         rows.length +
  //           " messages found but " +
  //           msgloadcount +
  //           " messagess succesfully uploaded from " +
  //           sheet.title
  //       );
  //     }
  //   } else {
  //     alert("No leads found");
  //   }
  // };
  useEffect(() => {
    getEmployees();
    getDest();
  }, []);

  const getEmployees = async () => {
    const data = await fetchEmployees();
    //const custdatalistfromdb= data.data

    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    setemp(sortedemp);

    const empsplist2 = data.data.filter((emp) => emp.role == "Sales" || emp.role=="TL" || emp.role == "SME");
    const empshortname2 = empsplist2.map((emp) => emp.short_name);
    let sortedemp2 = empshortname2.sort()
    setemp2(sortedemp2);
  };

  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  }

  const deletetrip = async () => {
    let tripid = prompt(
      "Please be very careful while deleting a trip. Once deleted, date cannot be restored. Enter trip id you want to delete:"
    );
    const deletetripResponse = await deleteTripbyId(tripid);

    if (
      deletetripResponse.status == 200 ||
      201 ||
      202 ||
      203 ||
      204 ||
      205 ||
      206 ||
      207
    ) {
      alert("Trip deleted successfully with id: " + tripid);
    } else {
      alert("Something went wrong. Contact support");
      window.location = "/";
    }
  };
  const handleleadSearch = async (e) => {
    // console.log(searchData2)
    if (searchData3.start_date && searchData3.end_date) {
      const data = await searchLeadsbyDate(
        searchData3.start_date,
        searchData3.end_date
      );
      setlistleadData(data.data);
      
      

      console.log(data.data);
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  };
  const handleleadSearch8 = async (e) => {
    // console.log(searchData2)
    if (searchData6.start_date && searchData6.end_date) {
      const data = await searchLeadsbyDate(
        searchData6.start_date,
        searchData6.end_date
      );
      setlistleadData4(data.data.filter(l=>(newgetqualitylead(l)=="Iron" || newgetqualitylead(l)=="Copper" || newgetqualitylead(l)=="Silver") && !l.work_done));
      
      

      //console.log(data.data);
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  };

   const handlemanualfrSearch = async (e) => {
    // console.log(searchData2)
    if (searchData7.start_date && searchData7.end_date) {
      const data = await getmanualfrbydate2(
        searchData7.start_date,
        searchData7.end_date
      );
      setlistleadData5(data.data);
      
      

      console.log(data.data);
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  };

  const handlerefleadSearch = async (e) => {
    // console.log(searchData2)
    if (searchData5.start_date && searchData5.end_date) {
      const data = await fetchReftrips(
        searchData5.start_date,
        searchData5.end_date
      );
      setlisttripData(data.data);

      //console.log(data.data);
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  };

  const handleleadSearch2 = async (e) => {
    // console.log(searchData2)
    if (searchData3.number) {
      const data = await fetchLeadsbyNumber(searchData3.number);
      setlistleadData2(data.data);

      console.log(data.data);
    } else {
      alert("Please enter all parameters -mobile number");
    }
  };

  const handleleadSearch3 = async (e) => {
    // console.log(searchData2)
    if (searchData3.email) {
      const data = await fetchLeadsbyEmail(searchData3.email);
      setlistleadData2(data.data);

      console.log(data.data);
    } else {
      alert("Please enter all parameters -email");
    }
  };

  const handleleadSearch4 = async (e) => {
    // console.log(searchData2)
    if (searchData4.email) {
      const data = await fetchLeadsbyEmail(searchData4.email);
      setlistleadData3(data.data);

      console.log(data.data);
    } else {
      alert("Please enter all parameters -email");
    }
  };

  const handleleadSearch5 = async (e) => {
    // console.log(searchData2)
    if (searchData4.number) {
      const data = await fetchTripsbyNumber(searchData4.number);
      setlistleadData3(data.data);

      console.log(data.data);
    } else {
      alert("Please enter all parameters -mobile number");
    }
  };

  const handleleadSearch6 = async (e) => {
    // console.log(searchData2)
    if (searchData4.name) {
      const data = await fetchTripsbyName(searchData4.name);
      setlistleadData3(data.data);

      console.log(data.data);
    } else {
      alert("Please enter all parameters -mobile number");
    }
  };

  const handleleadSearch7 = async (e) => {
    // console.log(searchData2)
    if (searchData3.name) {
      const data = await fetchLeadsbyName(searchData3.name);
      setlistleadData2(data.data);

      console.log(data.data);
    } else {
      alert("Please enter all parameters -name");
    }
  };

  var l1 = [];
  var t1=[]
  // if(leadfilterData.destination!=="All"){
  if (leadfilterData.trip_owner && leadfilterData.destination) {
    l1 = listleadData.filter(
      (leaddata) =>
        leaddata.lead_owner == leadfilterData.trip_owner &&
        leaddata.lead_destination.toLowerCase() ==
          leadfilterData.destination.toLowerCase()
    );
  } else if (leadfilterData.trip_owner) {
    l1 = listleadData.filter(
      (leaddata) => leaddata.lead_owner == leadfilterData.trip_owner
    );
  } else if (leadfilterData.destination) {
    l1 = listleadData.filter(
      (leaddata) => "lead_destination" in leaddata &&
        leaddata.lead_destination.toLowerCase() ==
        leadfilterData.destination.toLowerCase()
    );
  } else {
    l1 = listleadData;
  }
  if(leadfilterData.source){
    l1=l1.filter(lead=>lead.lead_platform==leadfilterData.source)
  }
  if(leadfilterData.wd){
    l1=l1.filter(lead=>lead.work_complete==leadfilterData.wd)
  }
  if(leadfilterData.fr){
    if(leadfilterData.fr=="Yes"){
    l1=l1.filter(lead=>lead.manual_fast_reach_attempted)
    }else{
      l1=l1.filter(lead=>!("manual_fast_reach_attempted" in lead && lead.manual_fast_reach_attempted))
    }
  }
  if(leadfilterData.model){
  if(leadfilterData.model=="Beta"){
    l1=l1.filter(l => "model_beta" in l && l.model_beta=="Beta")
  }else{
    l1=l1.filter(l => !("model_beta" in l && l.model_beta=="Beta"))
  }
  
}
   if(leadfilterData.canc_reason){
    l1=l1.filter(lead=>lead.canc_reason==leadfilterData.canc_reason)
  }
  if(leadfilterData.quality){
    if(leadfilterData.quality=="High Quality"){
      l1=l1.filter(lead=>newgetqualitylead(lead)!=="Iron" && newgetqualitylead(lead)!=="Copper" && newgetqualitylead(lead)!=="Silver")
    }else{
    l1=l1.filter(lead=>newgetqualitylead(lead)==leadfilterData.quality)
  }
}
  // }
  if(searchData5.trip_owner){
    listtripData=listtripData.filter(trip=>trip.trip_owner==searchData5.trip_owner)
  }
  if(searchData5.destination){
    listtripData=listtripData.filter(trip=>trip.primary_destination==searchData5.destination)
  }
  

  var l2=[...listleadData2]
  if(filterdata1.destination){
    l2=l2.filter(l=>l.lead_destination==filterdata1.destination)
  }
  if(filterdata1.owner){
    l2=l2.filter(l=>l.lead_owner==filterdata1.owner)
  }

  if(role=="Sales"  || role=="SME" ){
    l2=l2.filter(l=>l.lead_owner==cuser)
  }

  const l21=reversesortByKey(l2,"lead_id")

  var l3=[...listleadData3]
  if(filterdata2.destination){
    l3=l3.filter(l=>l.primary_destination==filterdata2.destination)
  }
  if(filterdata2.owner){
    l3=l3.filter(l=>l.trip_owner==filterdata2.owner)
  }
  if(filterdata2.status){
    l3=l3.filter(l=>l.trip_status==filterdata2.status)
  }

  if(role=="Sales"  || role=="SME" ){
    l3=l3.filter(l=>l.trip_owner==cuser)
  }

  const l31=reversesortByKey(l3,"trip_id")

  //console.log(l3)
  //-----------------------------Iron Leads------------------------------------
  if(listleadData4.length>0){
    var leadlist=[...listleadData4]
    if(leadfilterData.destination){
      leadlist=leadlist.filter(l=>l.lead_destination==leadfilterData.destination)
    }
    if(leadfilterData.trip_owner){
      leadlist=leadlist.filter(l=>l.lead_owner==leadfilterData.trip_owner)
    }
  }

  const leaddatalistdisplay = l1.map((data) => ({
    lead_id: data.lead_id,
    id: listleadData.indexOf(data),
    lead_name: data.lead_name,
    phone:role && role=="Admin"?data.mobile_number:"",
    lead_status: newgetqualitylead(data),
    lead_destination: data.lead_destination,
    email: data.email_id,
    lead_createdAt: data.createdAt,
    lead_source:data.lead_platform,
    lead_platform:data.lead_campaign,
    start_date:data.lead_travel_date,
    lead_owner: data.lead_owner,
    lead_assignedAt: new Date(data.assignedAt).toLocaleString(),
    meta_campaign: data.lead_meta_campaign,
    landing_page:data.landing_page,
    lead_canc:data.canc_reason,
    work_done_time: new Date(data.work_complete_date).toLocaleString(),
    time_to_action:((new Date(data.assignedAt).getTime()-new Date(data.createdAt).getTime())/(1000*60*60)).toFixed(2),
    potential:"potential" in data?data.potential:"",
    only_wa:data.only_whatsapp,
    lead_pax:data.lead_pax,
    lead_travel_date:data.lead_travel_date,
    caller:"callrecord" in data && data.callrecord.length>0?data.callrecord[0].answered_agent_name:"",
    gap:"callrecord" in data && data.callrecord.length>0?Math.round((new Date(data.callrecord[0].start_stamp).getTime()-new Date(data.createdAt).getTime())/(1000*60)):"",
    fc_time:"callrecord" in data && data.callrecord.length>0?data.callrecord[0].start_stamp:"",
    manual_fr:data.manual_fast_reach_attempted+" - "+data.manual_fast_reach_attempted_time,
    call_duration:"callrecord" in data && data.callrecord.length>0?parseInt(data.callrecord[0].outbound_sec):"",
    call_creation_category:classifyleadcreationtime(data),
    fr_wa:data.fast_reach_whatsapp,
    ref_code:data.ref_code,
  }));

  const leaddatalistdisplay3 = l21.map((data) => ({
    lead_id: data.lead_id,
    id: listleadData2.indexOf(data),
    lead_name: data.lead_name,
    phone:role && role=="Admin"?data.mobile_number:"",
    lead_status: data.lead_status,
    lead_destination: data.lead_destination,
    lead_createdAt: new Date(data.createdAt)
      .toLocaleString()
      .split(",")
      .slice(0, 1),
    lead_createdAt_time: new Date(data.createdAt)
      .toLocaleString()
      .split(",")
      .slice(1, 2),
    lead_owner: data.lead_owner,
    lead_assignedAt: new Date(data.assignedAt).toLocaleString(),
    work_done: data.work_complete,
    quality:newgetqualitylead(data),
    work_done_time: new Date(data.work_complete_date).toLocaleString(),
    time_to_action:data.work_complete_date?(new Date(data.work_complete_date).getTime()-new Date(data.assignedAt).getTime()).toFixed(2)/(1000*60*60):0,
    potential:data.potential,
    only_wa:data.only_whatsapp,
  }));

  const leaddatalistdisplay4 = l31.map((data) => ({
    trip_id:data.trip_id,
    id: listleadData3.indexOf(data),
    name:data.cust_name,
    phone:role && role=="Admin"?data.primary_mobile_number:"",
    trip_destination:data.primary_destination,
    createdAt:data.createdAt,
    trip_owner:data.trip_owner,
    status:data.trip_status
  }));

  const leaddatalistdisplay5 = listleadData5.map((data) => ({
    lead_id:data.lead_id,
    id: listleadData5.indexOf(data),
    manualfr:data.manual_fast_reach,
    fr: data.fast_reach,
    fra: data.fast_reach_attempted,
    manual_fra_time:data.manual_fast_reach_attempted_time,
    quote_time:data.quote_time
  }));

  const leaddatalistdisplay2 = leadlist.map((data) => ({
    lead_id: data.lead_id,
    id: leadlist.indexOf(data),
    lead_name: data.lead_name,
    phone:role && role=="Admin"?data.mobile_number:"",
    lead_status: newgetqualitylead(data),
    lead_destination: data.lead_destination,
    email: data.email_id,
    lead_createdAt: new Date(data.createdAt).toLocaleString(),
    lead_source:data.lead_source,
    lead_owner: data.lead_owner,
    lead_assignedAt: data.lead_travel_date,
    work_done: data.work_complete,
    lead_canc:data.canc_reason,
    work_done_time: new Date(data.work_complete_date).toLocaleString(),
    time_to_action:((new Date(data.assignedAt).getTime()-new Date(data.createdAt).getTime())/(1000*60*60)).toFixed(2),
    potential:"potential" in data?data.potential:"",
    only_wa:data.only_whatsapp,
  }));

  const reftripdatalistdisplay=listtripData.map(data => ({
    trip_id:data.trip_id,
    id: listtripData.indexOf(data),
    name:data.cust_name,
   
    trip_destination:data.primary_destination,
    createdAt:data.createdAt,
    trip_owner:data.trip_owner,
    status:data.trip_status
  })
)

  const gridcellclicklead = (id) => {
    window.open("/lead/" + id, "_blank");
    //console.log("/custdataentry/"+id);
  };

  const gridcellclick=(id)=>{
    window.open("/tripdataentry/" + id, '_blank');
    //console.log("/custdataentry/"+id);
  }

  const leadbasedcustdata=async()=>{
    try{
      if(searchData8.start_date && searchData8.end_date){
      const leadData=await fetchleadbasedcustdata(searchData8.start_date, searchData8.end_date)
      console.log(leadData.data)
      setleadcustdata(leadData.data.lead)
      setleadcustdata2(leadData.data.cust)
      setleadcustdata3(leadData.data.trip)
      setleadcustdata4(leadData.data.quote)
      }else{
        alert("Enter dates and try again")
      }
    }catch(err){
      console.log(err)
    }
  }

  const getcustid=(number, id)=>{
    const temp=leadcustdata2.filter(c=>c.primary_mobile_number==number)
    const temp2=leadcustdata.filter(c=>c.mobile_number==number)
  
    if(temp.length>0){
        if(id==1){
      return temp[0].cust_id
      }else if(id==2){
        return temp[0].follow_up.roc
      }else if(id==3){
          return temp[0].follow_up.status
      }else{
        return "updatedAt" in temp[0].follow_up?new Date(temp[0].follow_up.updatedAt).getTime()>new Date(temp2[0].createdAt).getTime():(new Date(temp[0].createdAt).getTime()>new Date(temp2[0].createdAt).getTime()?true:"")
      }
    }else{
      return ""
    }
  
  }

    const gettripid=(number, id)=>{
    const temp=leadcustdata3.filter(c=>c.primary_mobile_number==number)
  
    if(temp.length>0){
        if(id==1){
      return temp[temp.length-1].trip_id
      }else if(id==2){
          return temp[temp.length-1].trip_status
      }else{
        return temp[temp.length-1].createdAt
      }
    }else{
      return ""
    }
  
  }

  const getquoteid=(id)=>{
    const temp=leadcustdata4.filter(c=>c.trip_id==id)
  
    if(temp.length>0){
      return temp[0].quote_id
    }else{
      return ""
    }
  
  }

const searchbyreactivated=async()=>{
  try{
    if(searchData9.start_date && searchData9.end_date){
    const data=await reactivatebydate(searchData9.start_date, searchData9.end_date)
    setlisttripData2(data.data)
    }else{
    alert("Enter dates and try again")
    }
  }catch(err){
    console.log(err)
  }
}

const getCount=(fup, rd)=>{
  var count=0
  for(let i=0;i<fup.length;i++){
    if(new Date(fup[i].date).getTime()>new Date(rd).getTime()){
      count++
    }
  }
  return count
}

const addselection=()=>{
    if(leadfilterData.assign_to == undefined){
      alert("Missing sales person name to assign")
    } else if(selection.length==0){
      alert("No item selected")
    }else{
      const leadlist=selection.map(select => leadcustlistdisplay2[select].lead_id)
      let tempobj={
      name:leadfilterData.assign_to,
      leads:leadlist
    }
    setleadselectionData([...leadselectionData, tempobj])
    }
    
  }

  const newassign= async() => {
      try{

  
      console.log(leadselectionData)
      const data=await fetchfunnellength(leadfilterData.assign_to)
      console.log(data)
      if(data.data<130){
        const count=openfupcountbysp(leadfilterData.assign_to)
        console.log(count)
        const opendata = await fetchCustomersbyOwner(leadfilterData.assign_to);
        console.log(opendata.data)
        if(opendata.data.length<6){
      var alreadyassigned=[]
      if(leadselectionData.length>0){
        for (let i=0;i<leadselectionData.length;i++){
         
          if("leads" in leadselectionData[i] && leadselectionData[i].leads.length>0){
          for(let j=0;j<leadselectionData[i].leads.length;j++){
            if(!alreadyassigned.includes(leadselectionData[i].leads[j])){
              alreadyassigned=[...alreadyassigned,leadselectionData[i].leads[j]]
              
              // const data = await fetchLeadbyId(leadselectionData[i].leads[j]);
              // data.data.lead_owner=leadselectionData[i].name
              // data.data.assignedAt=new Date()
              console.log(leadselectionData[i].leads[j], leadselectionData[i].name, cuser)
              const data = await newupdateLeaddata3(leadselectionData[i].leads[j], leadselectionData[i].name, cuser);
            }
            
          }
        }
        }
        window.location.reload();
      } else if(selection.length==0){
        alert("No item selected")
      }
    }else{
      alert("Cannot assign leads to "+leadfilterData.assign_to+" as customer follow ups are pending")
    }
    }else{
      alert("Cannot assign leads to "+leadfilterData.assign_to+" as funnel size is already too high")
    }

      
    }catch(err){
      console.log(err)
    }
    };

  //console.log(leadcustdata)

  var leadcustlistdisplay=leadcustdata.map(data => ({
    lead_id:data.lead_id,
    mobile:data.mobile_number,
    canc_reason:data.canc_reason?data.canc_reason:"",
    cust_id:getcustid(data.mobile_number,1),
    cust_canc_reason:getcustid(data.mobile_number,2),
    status:getcustid(data.mobile_number,3),
    trip_id:gettripid(data.mobile_number,1),
    trip_status:gettripid(data.mobile_number,2),
    
    check_updated:getcustid(data.mobile_number,4),
    wd:data.work_complete,
    dest:data.lead_destination,
    owner:data.lead_owner,
    lead_created:data.createdAt,
    trip_created:gettripid(data.mobile_number,3),
    sumleadcalltime:getLeadCallTimeSummary(data),
  })
)
leadcustlistdisplay=sortByKey(leadcustlistdisplay, "Lead_id")
//console.log(leadcustlistdisplay)
if(searchData8.filter){
  leadcustlistdisplay=leadcustlistdisplay.filter(d=>(((d.lead_owner=="Abhishek" || d.lead_owner=="RohitS" || d.lead_owner=="Asgar") && (d.cust_id=="" && d.canc_reason=="" && d.wd))||(d.cust_id && d.trip_id=="" &&  d.cust_canc_reason=="" && d.status=="Closed" && d.canc_reason=="")||(d.cust_id && d.trip_id=="" &&  d.check_updated=="" && d.canc_reason=="") ||(d.cust_id && d.trip_id && d.status=="Closed" && new Date(d.lead_created).getTime()>new Date(d.trip_created).getTime() && d.canc_reason==""  && !d.check_updated)))
}

 var leadcustlistdisplay2=leadcustlistdisplay.map(data => ({
    lead_id:data.lead_id,
    id: leadcustlistdisplay.indexOf(data),
    mobile:data.mobile,
    canc_reason:data.canc_reason,
    cust_id:data.cust_id,
    cust_canc_reason:data.cust_canc_reason,
    status:data.status,
    trip_id:data.trip_id,
    //quote_id:getquoteid(data.trip_id),
    trip_status:data.trip_status,
    check_updated:data.check_updated,
    wd:data.wd,
    dest:data.dest,
    owner:data.owner,
    sumleadcalltime:data.sumleadcalltime,
    // quality:getquality(data.lead_status,data.time_to_book, data.lead_platform, data.lead_travel_date, data.quality_upgrade, data.lead_passport,data.lead_campaign, data.flight_required, data.customer_type, data.manual_fast_reach_failed),
  })
)

 var leadcustlistdisplay3=listtripData2.map(data => ({
    trip_id:data.trip_id,
    id: listtripData2.indexOf(data),
    trip_status:data.trip_status,
    trip_owner:data.trip_owner,
    fup:"follow_up" in data?data.follow_up[data.follow_up.length-1].date:"",
    rdate:data.reactivate_date,
    fup_count:"follow_up" in data && data.follow_up.length>0?getCount(data.follow_up, data.reactivate_date):"",
    mobile:data.primary_mobile_number
  })
)

  return (
    <div>
      <br />
     
      <br></br>
      
      {role=="Admin" || role=="Manager" || role=="Marketing" || role=="TL"?(<div>
        <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Lead List - {leaddatalistdisplay.length}
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData3({ ...searchData3, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData3({ ...searchData3, end_date: e.target.value })
            }
          />
          <Button
            onClick={handleleadSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {role=="Admin" && leaddatalistdisplay.length>1?(<div>
                   <CSVLink data={leaddatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        </div>
        <FormGroup row className={classes.formgroup}>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="trip owner">Lead Owner</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Trip Owner"
            value={leadfilterData.trip_owner}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                trip_owner: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            {emp.map((emp) => {
              return <MenuItem value={emp}>{emp}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="quality">Quality</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Quality"
            value={leadfilterData.quality}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                quality: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
             <MenuItem value={"Rhodium"}>Rhodium</MenuItem>
            <MenuItem value={"Platinum"}>Platinum</MenuItem>
            <MenuItem value={"Diamond"}>Diamond</MenuItem>
            <MenuItem value={"Gold"}>Gold</MenuItem>
            <MenuItem value={"Silver"}>Silver</MenuItem>
            <MenuItem value={"Copper"}>Copper</MenuItem>
            <MenuItem value={"Copper(u)"}>Copper(u)</MenuItem>
            <MenuItem value={"Titanium"}>Titanium</MenuItem>
            <MenuItem value={"Iron"}>Iron</MenuItem>
            <MenuItem value={"High Quality"}>High Quality</MenuItem>
            <MenuItem value={"Old High Quality"}>Old High Quality</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Destination">Destination</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Destination"
            value={leadfilterData.destination}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                destination: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Bali"}>Bali</MenuItem>
            {dest.map((dest) => {
              return <MenuItem value={dest}>{dest}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Source">Source</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Source"
            value={leadfilterData.source}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                source: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Meta"}>Meta</MenuItem>
            <MenuItem value={"Manual"}>Manual</MenuItem>
            <MenuItem value={"Reference"}>Reference</MenuItem>
            <MenuItem value={"Manual Entry"}>Manual Entry</MenuItem>
            <MenuItem value={"TripCrafters"}>TripCrafters</MenuItem>
            <MenuItem value={"TripClap"}>TripClap</MenuItem>
            <MenuItem value={"PayTM"}>PayTM</MenuItem>
            <MenuItem value={"Google"}>Google</MenuItem>
            <MenuItem value={"Email"}>Email</MenuItem>
            <MenuItem value={"Organic"}>Organic</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="FR">Manual Fast Reach Attempted</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="FR"
            value={leadfilterData.fr}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                fr: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"No"}>No</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Model">Model</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Model"
            value={leadfilterData.fr}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                model: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Alpha"}>Alpha</MenuItem>
            <MenuItem value={"Beta"}>Beta</MenuItem>
          </Select>
        </FormControl>
         <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="CR">Canc Reason</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="CR"
            value={leadfilterData.canc_reason}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                canc_reason: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Wrong number"}>Wrong number</MenuItem>
            <MenuItem value={"Number unreachable"}>Number unreachable</MenuItem>
            <MenuItem value={"Cancelled by marketing"}>Cancelled by marketing</MenuItem>
            <MenuItem value={"Duplicate Lead"}>Duplicate Lead</MenuItem>
            <MenuItem value={"Already Booked"}>Already Booked</MenuItem>
            <MenuItem value={"Denied placing lead"}>Denied placing lead</MenuItem>
             <MenuItem value={"Not serving destination"}>Not serving destination</MenuItem>
                            <MenuItem value={"Budget Problem"}>Budget Problem</MenuItem>
                            <MenuItem value={"Solo Traveller"}>Solo Traveller</MenuItem>
            <MenuItem value={"Others"}>Others</MenuItem>
            
          </Select>
        </FormControl>
        </FormGroup>
        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>

      <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          FR Lead List
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Manual FR On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData7({ ...searchData7, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Manual FR On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData7({ ...searchData7, end_date: e.target.value })
            }
          />
          <Button
            onClick={handlemanualfrSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          
        </div>
     
        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay5}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns5}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>

      <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          LQ Lead List
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, end_date: e.target.value })
            }
          />
          <Button
            onClick={handleleadSearch8}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {role=="Admin" && leaddatalistdisplay2.length>1?(<div>
                   <CSVLink data={leaddatalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        </div>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="trip owner">Trip Owner</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Trip Owner"
            value={leadfilterData.trip_owner}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                trip_owner: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            {emp2.map((emp) => {
              return <MenuItem value={emp}>{emp}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Destination">Destination</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Destination"
            value={leadfilterData.destination}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                destination: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Bali"}>Bali</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
            {dest.map((dest) => {
              return <MenuItem value={dest}>{dest}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="wd">Work Done</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="wd"
            value={leadfilterData.destination}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                wd: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>
       

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay2}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns2}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>

      <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Referral Leads
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData5({ ...searchData5, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData5({ ...searchData5, end_date: e.target.value })
            }
          />
          <Button
            onClick={handlerefleadSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        
        </div>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="trip owner">Trip Owner</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Trip Owner"
            value={searchData5.trip_owner}
            onChange={(e) =>
              setsearchData5({
                ...searchData5,
                trip_owner: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            {emp.map((emp) => {
              return <MenuItem value={emp}>{emp}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Destination">Destination</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Destination"
            value={searchData5.destination}
            onChange={(e) =>
              setsearchData5({
                ...searchData5,
                destination: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Bali"}>Bali</MenuItem>
            {dest.map((dest) => {
              return <MenuItem value={dest}>{dest}</MenuItem>;
            })}
          </Select>
        </FormControl>
        

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={reftripdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={columns3}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>

       <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Cust Search
        </Typography>
            <br></br>
            <p>Takes 30 seconds to load</p>
        <div align="center">
          <TextField
            variant="standard"
            type="date"
            label="Lead Created On or After"
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) =>
              setsearchData8({ ...searchData8, start_date: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="date"
            label="Lead Created Before"
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) =>
              setsearchData8({ ...searchData8, end_date: e.target.value })
            }
          />
           <Button
            onClick={leadbasedcustdata}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
            <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="problem">Problem</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="problem"
            value={searchData8.filter}
            onChange={(e) =>
              setsearchData8({ ...searchData8, filter: e.target.value })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            
          </Select>
        </FormControl>
        
          
        </div>
        <div align="center">
          <FormControl
                  style={{
                    minWidth: 320,
                    marginTop: 16,
                    marginRight: 32,
                    marginLeft: 5,
                  }}
                >
                  <InputLabel id="primary destination">
                    Primary Destination
                  </InputLabel>
                  <Select
                     value={filterdata2.destination}
                    classname={classes.textField}
                    labelId="primary destination"
                    onChange={(e) => setfilterdata2({...filterdata2, destination:e.target.value})}
                  >
                    <MenuItem value={""}>Clear</MenuItem>
                    {dest.map((dest) => {
                      return <MenuItem value={dest}>{dest}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
                <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={filterdata2.owner}
              onChange={(e) => setfilterdata2({...filterdata2, owner:e.target.value})}
            >
            <MenuItem value={""}>Clear</MenuItem>
             {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="Trip Status">Trip Status</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Trip Status"
              value={filterdata2.status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setfilterdata2({...filterdata2, status:e.target.value})}
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"New"}>New</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
              <MenuItem value={"Hot"}>Hot</MenuItem>
              <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
              <MenuItem value={"Converted"}>Converted</MenuItem>
              <MenuItem value={"Postponed"}>Postponed</MenuItem>
              <MenuItem value={"Closed"}>Closed</MenuItem>
              <MenuItem value={"Dropped After Booking"}>Dropped After Booking</MenuItem>
              
            </Select>
          </FormControl>
           <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                      <InputLabel id="assign">Assign To</InputLabel>
                          <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Assign To" value={leadfilterData.assign_to} onChange={(e)=> setleadfilterData({...leadfilterData, assign_to: e.target.value})}>
                         
                          {emp.map((emp) => {
                          return <MenuItem value={emp}>{emp}</MenuItem>;
                        })}
                        
                              
                          
                          </Select>
                          </FormControl>
           <Button
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      onClick={addselection}
                    > Add
                    </Button>
                    {role=="Admin" || role=="Manager" && leadselectionData.length>0?(
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      onClick={preventDoubleClick(newassign)}
                    > New Assign
                    </Button>
                    ):("")}
                </div>
            {role=="Admin" && leadcustlistdisplay2.length>1?(<div>
                   <CSVLink data={leadcustlistdisplay2} headers={headers9}>Download CSV</CSVLink>
                   </div>
                ):("")}

        {leadcustlistdisplay2.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={leadcustlistdisplay2}
              onCellDoubleClick={(getValue) =>
                gridcellclicklead(getValue.row.lead_id)
              }
            checkboxSelection={searchData8.filter}
            onSelectionModelChange={(newSelection) => {
            setselection(newSelection);}}
              columns={columns9}
              autoPageSize
             
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
         Reactivate Trips
        </Typography>

        <div align="center">
          <TextField
            variant="standard"
            type="date"
            label="Reactivated On or After"
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) =>
              setsearchData9({ ...searchData9, start_date: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="date"
            label="Reactivated Before"
            InputLabelProps={{ shrink: true }}
            className={classes.textField}
            onChange={(e) =>
              setsearchData9({ ...searchData9, end_date: e.target.value })
            }
          />
           <Button
            onClick={searchbyreactivated}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
                        
        </div>
          {role=="Admin" && leadcustlistdisplay3.length>1?(<div>
                   <CSVLink data={leadcustlistdisplay3} headers={headers10}>Download CSV</CSVLink>
                   </div>
                ):("")}
        
        {leadcustlistdisplay3.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={leadcustlistdisplay3}
              onCellDoubleClick={(getValue) =>
                gridcellclick(getValue.row.trip_id)
              }
              columns={columns10}
              autoPageSize
             
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
      </div>):("")}
     
    </div>
  );
};

export default Lead;
